import React, { Suspense, lazy } from 'react';
import { CookiesProvider } from 'react-cookie';
import Loading from './components/loading/Loading';
const AppContainer = lazy(() => import('./containers/App'));
const App = () => (React.createElement(Suspense, { fallback: React.createElement(Loading, null) },
    React.createElement(CookiesProvider, null,
        React.createElement(AppContainer, null))));
export default App;
